/**
 * Layout Switcher Component
 * Icon-based toggle between boxed and fluid layout modes
 */

import React from "react";
import { Maximize2, Minimize2 } from "lucide-react";
import { Button } from "../../ui/button";

interface LayoutSwitcherProps {
  isFluid: boolean;
  onLayoutChange: (isFluid: boolean) => void;
}

export function LayoutSwitcher({
  isFluid,
  onLayoutChange,
}: LayoutSwitcherProps) {
  return (
    <Button
      variant="outline"
      size="sm"
      onClick={() => onLayoutChange(!isFluid)}
      className="gap-2"
      title={isFluid ? "Switch to Boxed Layout" : "Switch to Fluid Layout"}
    >
      {isFluid ? (
        <>
          <Maximize2 className="h-4 w-4" />
          <span className="hidden sm:inline">Fluid</span>
        </>
      ) : (
        <>
          <Minimize2 className="h-4 w-4" />
          <span className="hidden sm:inline">Boxed</span>
        </>
      )}
    </Button>
  );
}
